import React from 'react';
import IdentityLink from './IdentityLink';
import { formatDate, formatDecimal, formatDocument, formatMoney } from './contract';
import StageList from './StageList';

const missing = 'Não informado';
const names = (items) =>
  (items || [])
    .map((item) => item.name)
    .filter(Boolean)
    .join(' / ');
const place = (point) => [point?.city, point?.province].filter(Boolean).join(' - ') || missing;
const columns = [
  {
    key: 'position',
    label: '#',
    width: 44,
    resizable: false,
    value: (_, i) => String(i + 1).padStart(2, '0'),
  },
  {
    key: 'load',
    label: 'Carga',
    width: 130,
    value: (row) => String(row.id),
    render: (row, value) => (
      <IdentityLink
        to={`${row.type === 'PRE_LOAD' ? '/pre-cargas' : '/cargas'}/${row.loadId ?? row.id}`}
        aria-label={`Abrir ${row.type === 'PRE_LOAD' ? 'pré-carga' : 'carga'} ${row.id}`}
      >
        {value}
      </IdentityLink>
    ),
  },
  {
    key: 'client',
    label: 'Cliente',
    width: 220,
    value: (row) =>
      `${row.client?.name || 'Cliente não informado'} · ${formatDocument(row.client?.cnpj)}`,
  },
  { key: 'origin', label: 'Origem', width: 155, value: (row) => place(row.origin) },
  { key: 'destination', label: 'Destino', width: 155, value: (row) => place(row.destination) },
  {
    key: 'pickup',
    label: 'Coleta Agendada',
    width: 155,
    value: (row) => formatDate(row.scheduledPickupAt),
  },
  {
    key: 'delivery',
    label: 'Entrega Agendada',
    width: 160,
    value: (row) => formatDate(row.scheduledDeliveryAt),
  },
  {
    key: 'amount',
    label: 'Valor a Receber',
    width: 125,
    className: 'tc-k-cell-amount',
    value: (row) => {
      const quoted = row.amount === null && row.sourceAmount != null;
      const value = formatMoney(
        quoted ? row.sourceAmount : row.amount,
        quoted ? row.sourceCurrency || null : 'BRL',
      );
      return quoted ? `${value} · Valor original; total em reais não informado.` : value;
    },
  },
  {
    key: 'product',
    label: 'Produto',
    width: 160,
    value: (row) =>
      [
        row.product?.name || missing,
        row.quantity?.weight != null ? `${formatDecimal(row.quantity.weight)} kg` : null,
        row.quantity?.volume != null ? `Volume: ${row.quantity.volume}` : null,
        row.quantity?.pallets != null ? `Pallets: ${row.quantity.pallets}` : null,
      ]
        .filter(Boolean)
        .join(' · '),
  },
  {
    key: 'vehicle',
    label: 'Veículo',
    width: 170,
    value: (row) =>
      [
        names(row.vehicleProfile?.vehicleTypes),
        names(row.vehicleProfile?.bodyTypes),
        names(row.vehicleProfile?.implementTypes),
      ]
        .filter(Boolean)
        .join(' · ') || missing,
  },
  {
    key: 'tracking',
    label: 'Rastreado',
    width: 130,
    value: (row) =>
      [
        row.tracking?.required === true
          ? 'Sim'
          : row.tracking?.required === false
            ? 'Não'
            : missing,
        row.tracking?.tracker?.name,
      ]
        .filter(Boolean)
        .join(' · '),
  },
  {
    key: 'observations',
    label: 'Observações',
    width: 235,
    value: (row) =>
      [row.observations?.comments, row.observations?.additionalInfo].filter(Boolean).join(' · ') ||
      missing,
  },
];

const definition = {
  code: 'AVAILABLE',
  title: 'PRÉ CARGAS / CARGAS',
  className: 'tc-k-load-list',
  countDescription: 'cargas ordenadas pela data de coleta',
  loadingLabel: 'pré-cargas e cargas',
  tableLabel: 'Lista de pré-cargas e cargas',
  emptyMessage: 'Nenhuma pré-carga ou carga disponível.',
};
export default function AvailableList(props) {
  return <StageList {...props} definition={definition} columns={columns} />;
}
